import { useNotification } from "../../context/NotificationContext"
import { notificationURL } from "../../utils/NotificationURL"
import { AlertErrorIcon, AlertInfoIcon, AlertSuccessIcon, CloseIcon, IconCheckSuccess } from "../iconSet/IconSet"


const NotifyIconMenu = () => {
    const { notificationData, readNotify, deleteNotify } = useNotification()

    const handleOnClick = async (id: string, topic: string) => {
        await readNotify(id)
        
        const link = notificationURL.get(topic)

        if (link)
        {
            window.location.href = link
        }
    }
    
    return (
        <div className='notify-icon-menu'>
            {notificationData.length > 0 ? notificationData.map((item, index) => (
                <div className={`notify-item ${item.isSeen ? 'seen' : 'not-seen'}`} key={index} onClick={() => handleOnClick(item.id || "", item.title || '')} onTouchStart={() => handleOnClick(item.id || "", item.title || '')}>
                    <div className='notify-icon notify-cell'>
                        {item.type === 'SUCCESS' ? (
                            <IconCheckSuccess width='2rem'/>
                        ) : item.type === 'ERROR' ? (
                            <AlertErrorIcon width='2rem'/>
                        ) : item.type === 'INFO' ? (
                            <AlertInfoIcon width='2rem'/>
                        ): null}
                    </div>
                    <div className='notify-header notify-cell'>
                        <span>{item.topic}</span>
                    </div>
                    <div className='notify-body notify-cell'>
                        <span>{item.message}</span>
                    </div>
                    <div className='notify-right notify-cell' onClick={() => deleteNotify(item.id || "")} onTouchStart={() => deleteNotify(item.id || "")}>
                        <CloseIcon width='1rem' color='var(--color-text)'/>
                    </div>
                </div>
            )) : (
                <div className='notify-empty'>
                    No any notification available
                </div>
            )}
        </div>
    )
}

export default NotifyIconMenu